import { useParams } from '@tanstack/react-router';
import { IAlarm } from '_/api/alarms/alarms.api';
import { useAlarm } from '_/hooks/useAlarms';
import React, { createContext, useContext, ReactNode } from 'react';

interface AlarmContextValue {
  alarmId: string | undefined;
  selectedAlarm: IAlarm | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

const AlarmContext = createContext<AlarmContextValue | undefined>(undefined);

export function AlarmProvider({ children }: { children: ReactNode }) {
  const params = useParams({ strict: false }) as Partial<{ alarmId?: string }>;
  const alarmId = params.alarmId || '';

  // Fetch the alarm using React Query
  const { data: selectedAlarm, isLoading, isError, error } = useAlarm(alarmId);

  const value: AlarmContextValue = {
    alarmId: alarmId,
    selectedAlarm: selectedAlarm || null,
    isLoading: isLoading,
    isError: isError,
    error: error as Error | null,
  };

  return <AlarmContext.Provider value={value}>{children}</AlarmContext.Provider>;
}

export function useAlarmContext() {
  const context = useContext(AlarmContext);
  if (context === undefined) {
    throw new Error('useAlarmContext must be used within an AlarmProvider');
  }
  return context;
}
